import React from "react";

export const SidebarBaseData = [
  {
    title: "General",
    cName: "nav-group",
    navList: [
      {
        title: "Inicio",
        path: "/",
        icon: <i className="bi bi-house" />,
        cName: "nav-text",
      },
      {
        title: "Perfiles",
        path: "/perfiles",
        icon: <i className="bi bi-person-badge" />,
        cName: "nav-text",
      },
      {
        title: "Calendario",
        path: "/agenda",
        icon: <i className="bi bi-calendar" />,
        cName: "nav-text",
      },
      {
        title: "Pacientes",
        path: "/pacientes",
        icon: <i className="bi bi-person-bounding-box" />,
        cName: "nav-text",
      },
      {
        title: "Estadisticas",
        path: "/stats",
        icon: <i className="bi bi-bar-chart-fill" />,
        cName: "nav-text",
      },
      {
        title: "Finanzas",
        icon: <i className="bi bi-cash-coin" />,
        cName: "nav-text",
        subNavList: [
          {
            title: "Ingresos",
            path: "/finanzas/ingresos",
            cName: "sub-nav-text",
          },
          {
            title: "Egresos",
            path: "/finanzas/egresos",
            cName: "sub-nav-text",
          },
          { title: "Estadisticas", path: "/finanzas", cName: "sub-nav-text" },
        ],
      },
    ],
  },
];
export const SidebarClinicData = [
  {
    title: "General",
    cName: "nav-group",
    navList: [
      {
        title: "Inicio",
        path: "/",
        icon: <i className="bi bi-house" />,
        cName: "nav-text",
      },
      {
        title: "Calendario",
        path: "/agenda",
        icon: <i className="bi bi-calendar" />,
        cName: "nav-text",
      },
      {
        title: "Pacientes",
        path: "/pacientes",
        icon: <i className="bi bi-person-bounding-box" />,
        cName: "nav-text",
      },
      {
        title: "Estadisticas",
        path: "/stats",
        icon: <i className="bi bi-bar-chart-fill" />,
        cName: "nav-text",
      },
    ],
  },
  {
    title: "Soporte",
    cName: "nav-group",
    navList: [
      {
        title: "Opciones",
        path: "/settings",
        icon: <i className="bi bi-gear" />,
        cName: "nav-text",
      },
      {
        title: "Ayuda",
        path: "/help",
        icon: <i className="bi bi-patch-question" />,
        cName: "nav-text",
      },
    ],
  },
];
export const SidebarAdminData = [
  {
    title: "General",
    cName: "nav-group",
    navList: [
      {
        title: "Inicio",
        path: "/",
        icon: <i className="bi bi-house" />,
        cName: "nav-text",
      },
      {
        title: "Perfiles",
        path: "/perfiles",
        icon: <i className="bi bi-person-badge" />,
        cName: "nav-text",
      },
      {
        title: "Calendario",
        path: "/agenda",
        icon: <i className="bi bi-calendar" />,
        cName: "nav-text",
      },
      {
        title: "Pacientes",
        path: "/pacientes",
        icon: <i className="bi bi-person-bounding-box" />,
        cName: "nav-text",
      },
      {
        title: "Estadisticas",
        path: "/stats",
        icon: <i className="bi bi-bar-chart" />,
        cName: "nav-text",
      },
      {
        title: "Finanzas",
        icon: <i className="bi bi-cash-coin" />,
        cName: "nav-text",
        subNavList: [
          {
            title: "Ingresos",
            path: "/finanzas/ingresos",
            cName: "sub-nav-text",
          },
          {
            title: "Egresos",
            path: "/finanzas/egresos",
            cName: "sub-nav-text",
          },
          { title: "Estadisticas", path: "/finanzas", cName: "sub-nav-text" },
        ],
      },
      // {
      //   title: "Inventario",
      //   path: "/inventario",
      //   icon: <i className="bi bi-box2" />,
      //   cName: "nav-text",
      // },
    ],
  },
  {
    title: "Soporte",
    cName: "nav-group",
    navList: [
      // {
      //   title: "Opciones",
      //   path: "/settings",
      //   icon: <i className="bi bi-gear" />,
      //   cName: "nav-text",
      // },
      // {
      //   title: "Ayuda",
      //   path: "/help",
      //   icon: <i className="bi bi-patch-question" />,
      //   cName: "nav-text",
      // },
    ],
  },
];

export const SidebarDataPermissions = {
  ADM: SidebarAdminData,
  CYG: SidebarBaseData,
  CLI: SidebarBaseData,
  MOD: SidebarBaseData,
};
